// state/useTrailerStore.ts (or use local state in YardMap.tsx if simpler)

import { create } from 'zustand';
import { Trailer } from './trailer';

interface TrailerState {
  trailers: Trailer[];
  addTrailer: (trailer: Trailer) => void;
  updateTrailer: (id: string, data: Partial<Trailer>) => void;
  removeTrailer: (id: string) => void;
  emptyTrailer: () => void;
}

export const useTrailerStore = create<TrailerState>((set) => ({
  trailers: [],
  addTrailer: (trailer) =>
    set((state) => ({ trailers: [...state.trailers, trailer] })),
  updateTrailer: (id, data) =>
    set((state) => ({
      trailers: state.trailers.map((t) =>
        t.id === id ? { ...t, ...data } : t
      ),
    })),
  removeTrailer: (id) =>
    set((state) => ({
      trailers: state.trailers.filter((t) => t.id !== id),
    })),
    emptyTrailer:()=>
      set(() => ({
      trailers: [],
    })),
}));